import { SkeletonLoader } from "../../SkeletonLoader";

type SectionSkeletonProps = {
  rows?: number;
  "data-testid"?: string;
};

export const SectionSkeleton = ({
  rows = 3,
  "data-testid": testId,
}: SectionSkeletonProps) => (
  <div aria-busy="true" data-testid={testId} className="flex flex-col gap-3">
    {Array.from({ length: rows }, (_, row) => (
      <SkeletonLoader key={row} height={48} variant="rounded" />
    ))}
  </div>
);
